<div class="navBarMom">
	<nav [class.not-home]="router.url !== '/'" class="navbar navbar-expand-lg">
		<a class="navbar-brand" href="#">Lupino</a>
		<button
			aria-controls="navbarNav"
			aria-expanded="false"
			aria-label="Toggle navigation"
			class="navbar-toggler"
			data-bs-target="#navbarNav"
			data-bs-toggle="collapse"
			type="button"
		>
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse justify-content-end" id="navbarNav">
			<ul class="navbar-nav">
				<li class="nav-item">
					<a class="nav-link disabled-link" onclick="event.preventDefault();" routerLink="/campagnes">Campagnes</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" routerLink="/characters">Héros</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" routerLink="/pnjs">Personnages non joueur</a>
				</li>
				<li class="nav-item dropdown">
					<a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#"
					   id="userDropdown" role="button">
						L'univers
					</a>
					<ul aria-labelledby="userDropdown" class="dropdown-menu">
						<li>
							<a class="dropdown-item" routerLink="/races">Les races</a>
							<a class="dropdown-item" routerLink="/lore">Le lore</a>
							<a class="dropdown-item" routerLink="/items">Les items</a>
							<div class="dropdown-divider"></div>
							<a [routerLink]="['/mycampains', 1]" class="dropdown-item disabled-link"
							   onclick="event.preventDefault();"
							>Les documents</a
							>
						</li>
					</ul>
				</li>
				<li class="nav-item dropdown">
					<a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#"
					   id="userDropdown" role="button">
						<i class="bi bi-person"></i>
					</a>
					<ul aria-labelledby="userDropdown" class="dropdown-menu">
						@if (!(isLoggedIn$ | async)) {
							<li>
								<a class="dropdown-item" routerLink="/login">Connexion</a>
								<a class="dropdown-item" routerLink="/register">Inscription</a>
							</li>
						}
						@if (isLoggedIn$ | async) {
							<li>
								<a class="dropdown-item" routerLink="/profil">Mon profil</a>
								<a class="dropdown-item" routerLink="/mycharacters">Mes personnages</a>
								<a class="dropdown-item disabled-link" (click)="$event.preventDefault()"
								   [routerLink]="['/campagnes', 1]"
								>Mes campagnes</a
								>
								<div class="dropdown-divider"></div>
								@if (isAdmin$ | async) {
									<a class="dropdown-item" routerLink="/user-list">Listes des utilisateurs</a>
								}
								@if ((isAdmin$ | async) || (isMj$ |async)) {
									<a class="dropdown-item" routerLink="/mypnjs">Mes PNJs</a>
								}
								@if (isAdmin$ | async) {
									<div class="dropdown-divider"></div>
								}
								<a class="dropdown-item" (click)="logout()">Déconnexion</a>
							</li>
						}
					</ul>
				</li>
			</ul>
		</div>
	</nav>
	<app-ornement [size]="18" [thickness]="2" width="100%"></app-ornement>
</div>
